// v10/src/components/PeriodPicker.js
// Mini-PR pulido — selector de mes/año con dropdowns + flechas opcionales.
// Usado en AdminHobbsReport (libro de vuelos del admin) y PilotFlightLog (Mis vuelos).
import React from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const MONTHS = ['Enero','Febrero','Marzo','Abril','Mayo','Junio',
                'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

const PeriodPicker = ({
  month, year,
  onMonthChange, onYearChange,
  onPrev, onNext,
  isCurrentMonth,
  darkMode,
  compact = false,
}) => {
  const nowYear = new Date().getFullYear();
  const years = [];
  for (let y = nowYear + 1; y >= nowYear - 10; y--) years.push(y);

  const btnSize = compact ? 28 : 32;
  const selectFont = compact ? 12 : 13;
  const selectPadV = compact ? 5 : 6;

  const selectStyle = {
    appearance: 'none',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    border: 'none',
    outline: 'none',
    background: darkMode ? 'rgba(255,255,255,0.08)' : 'white',
    color: darkMode ? 'white' : '#0f172a',
    padding: `${selectPadV}px 26px ${selectPadV}px 10px`,
    borderRadius: 10,
    fontSize: selectFont,
    fontWeight: 700,
    fontFamily: 'inherit',
    cursor: 'pointer',
    backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path d='M1 1l4 4 4-4' stroke='${darkMode ? '%23ffffff99' : '%2364748b'}' stroke-width='1.5' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: `right 8px center`,
  };

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 6,
      background: darkMode ? 'rgba(255,255,255,0.06)' : '#f8fafc',
      border: darkMode ? '1px solid rgba(255,255,255,0.1)' : '1px solid #e2e8f0',
      borderRadius: 14, padding: 6,
    }}>
      {onPrev && (
        <motion.button onClick={onPrev} whileTap={{ scale: 0.9 }} aria-label="Mes anterior"
          style={{ width: btnSize, height: btnSize, borderRadius: 10, border: 'none', cursor: 'pointer',
            background: darkMode ? 'rgba(255,255,255,0.08)' : 'white',
            color: darkMode ? 'rgba(255,255,255,0.6)' : '#64748b',
            display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <ChevronLeft style={{ width: 16, height: 16 }} />
        </motion.button>
      )}

      <select value={month} onChange={e => onMonthChange(parseInt(e.target.value, 10))}
        style={selectStyle} aria-label="Mes">
        {MONTHS.map((m, i) => (
          <option key={i+1} value={i+1}>{m}</option>
        ))}
      </select>

      <select value={year} onChange={e => onYearChange(parseInt(e.target.value, 10))}
        style={selectStyle} aria-label="Año">
        {years.map(y => (
          <option key={y} value={y}>{y}</option>
        ))}
      </select>

      {onNext && (
        <motion.button onClick={onNext} disabled={isCurrentMonth} whileTap={{ scale: 0.9 }} aria-label="Mes siguiente"
          style={{ width: btnSize, height: btnSize, borderRadius: 10, border: 'none',
            cursor: isCurrentMonth ? 'not-allowed' : 'pointer',
            background: darkMode ? 'rgba(255,255,255,0.08)' : 'white',
            color: isCurrentMonth
              ? (darkMode ? 'rgba(255,255,255,0.2)' : '#cbd5e1')
              : (darkMode ? 'rgba(255,255,255,0.6)' : '#64748b'),
            display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <ChevronRight style={{ width: 16, height: 16 }} />
        </motion.button>
      )}
    </div>
  );
};

export default PeriodPicker;
